import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-amber-950 text-amber-200 pt-14 pb-8">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-10 mb-10">
          {/* Brand */}
          <div>
            <div className="font-display text-2xl text-orange-400 mb-2">BSM Bhojan Seva Mandal Foundation</div>
            <p className="text-amber-300 font-hindi text-base mb-4 italic">भोजन सेवा मंडल</p>
            <p className="text-sm text-amber-400 leading-relaxed">
              A registered non-profit organization dedicated to providing nutritious meals to people living in vulnerable and unstable housing conditions across Gujarat.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <div className="font-semibold text-orange-400 uppercase tracking-widest text-xs mb-4">Pages</div>
            <ul className="space-y-2">
              {[
                ['/', 'Home'],
                ['/about', 'About Us'],
                ['/contact', 'Contact'],
                ['/membership', 'Membership']
              ].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className="text-amber-300 hover:text-orange-400 transition-colors text-sm">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Info & Policies */}
          <div>
            <div className="font-semibold text-orange-400 uppercase tracking-widest text-xs mb-4">Information</div>
            <ul className="space-y-2">
              {[
                ['/faq', 'FAQs'],
                ['/privacy-policy', 'Privacy Policy'],
                ['/refund-policy', 'Refund Policy'],
                ['/terms-and-conditions', 'Terms And Conditions']
              ].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className="text-amber-300 hover:text-orange-400 transition-colors text-sm">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <div className="font-semibold text-orange-400 uppercase tracking-widest text-xs mb-4">Reach Us</div>
            <ul className="space-y-3 text-sm text-amber-300">
              <li className="flex items-start gap-2">
                <span>📍</span>
                <span>Amrut Complex 2nd floor, Opp. Royal Stationary, Anand Banglows chowk, Mavdi mainroad, Rajkot – 360004, Gujarat, India</span>
              </li>
              <li className="flex items-center gap-2">
                <span>📞</span>
                <a href="tel:+919081795075" className="hover:text-orange-400 transition-colors">+91 90817 95075</a>
              </li>
              <li className="flex items-center gap-2">
                <span>✉️</span>
                <a href="mailto:bsmbhojansevamandalfoundation@gmail.com" className="hover:text-orange-400 transition-colors">bsmbhojansevamandalfoundation@gmail.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-amber-800 pt-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-amber-500">
          <span>© 2026 BSM Bhojan Seva Mandal Foundation. All rights reserved. | Reg. No. 173136</span>
          <span className="lotus-divider text-base">🪷 ॐ 🪷</span>
        </div>
      </div>
    </footer>
  );
}
